/**
 * Active Ionic page scroller inside `#main-tabs` (last visible `.ion-page`).
 * Shared by tab-bar compact tracking and tap-active-tab-to-scroll-top (DEV-440).
 */
export function queryActiveShellScrollContent(): HTMLIonContentElement | null {
  const outlet = document.querySelector('#main-tabs');
  if (!outlet) {
    return null;
  }

  const pages = outlet.querySelectorAll('.ion-page');
  let active: Element | null = null;
  for (const page of pages) {
    if (!page.classList.contains('ion-page-hidden')) {
      active = page;
    }
  }
  if (!active) {
    return null;
  }

  return (
    (active.querySelector(
      'ion-content.shell-page-content',
    ) as HTMLIonContentElement | null) ??
    (active.querySelector('ion-content') as HTMLIonContentElement | null)
  );
}

function scrollDurationMs(): number {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return 0;
  }
  return 300;
}

/** Scroll the visible shell tab page to the top (Instagram / Apple Music). */
export async function scrollActiveShellPageToTop(): Promise<void> {
  const ionContent = queryActiveShellScrollContent();
  if (!ionContent) {
    return;
  }

  const duration = scrollDurationMs();

  if (typeof ionContent.scrollToTop === 'function') {
    await ionContent.scrollToTop(duration);
    return;
  }

  if (typeof ionContent.scrollToPoint === 'function') {
    await ionContent.scrollToPoint(0, 0, duration);
    return;
  }

  if (typeof ionContent.getScrollElement !== 'function') {
    return;
  }

  const scrollEl = await ionContent.getScrollElement();
  scrollEl.scrollTo({
    top: 0,
    behavior: duration > 0 ? 'smooth' : 'auto',
  });
}
